import React from 'react';

export class EmbeddedVideo extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  get youtubeId () {
    if (this.props.uri.indexOf('youtube') === -1) return false;

    function getId (url) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      if (match && match[2].length === 11) return match[2];
      else return 'error';
    }

    var videoId = getId(this.props.uri);

    return videoId;
  }

  get vimeoId () {
    if (this.props.uri.indexOf('vimeo') === -1) return false;
    var videoId = this.props.uri.split('/').reverse()[0];
    return videoId;
  }


  render () {
    return (
      <div>
        { this.youtubeId && <iframe className="youtube" width="560" height="315" src={`//www.youtube.com/embed/${this.youtubeId}`} frameBorder="0" allowFullScreen /> }
        { this.vimeoId && <iframe className="youtube" width="560" height="315" src={`//player.vimeo.com/video/${this.vimeoId}`} frameBorder="0" allowFullScreen /> }
      </div>
    );
  }
}
